import { Button, Collapse, Container, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { useConcurso } from '../../../../providers/ConcursoProvider';
import { Accordion } from '../../../Accordion/Accordion';
import { AccordionItem } from '../../../Accordion/AccordionItem';
import { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getDatosExpediente, useActoAdministrativo } from '../../../../appStore/actoAdministrativo';
import { cleanMsg, postPublicar, useConvocatoria } from '../../../../appStore/convocatoria';
import { finEtapa } from '../gestionConcursoSlice';
import { useHistory } from 'react-router';
import FullLoading from '../../../CompUtils/FullLoading';
import AlertDialog from '../../../CompUtils/AlertDialog';
import { PuestosTable } from '../TramitarConcursos/Commons/PuestosTable/PuestosTable';

// const { roles } = useSelector(userSelector);
const SpacedSpan = styled.span`
  margin-right: 18px;
`;

export const Publicar = () => {
  const [visible, setVisible] = useState(false);
  const { idLlamadoConcurso, ...concurso } = useConcurso();
  const { esCoordinadorConcursal } = concurso;
  const { error, loading: loadingPublicar, success } = useConvocatoria();
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading } = useActoAdministrativo();
  const { nroResolucionBora, fresolucionBora, linkResolucionBora } =
    concurso.expedienteLlamadoConcurso;

  const finalLink = useMemo(() => {
    if (!linkResolucionBora) return null;
    if (linkResolucionBora.startsWith('http')) return linkResolucionBora;
    return 'http://' + linkResolucionBora;
  }, [linkResolucionBora]);

  useEffect(() => {
    dispatch(getDatosExpediente({ idLlamadoConcurso }));
  }, [dispatch, idLlamadoConcurso]);

  return (
    <Container>
      <h2 className="text-info text-center ">PUBLICAR</h2>
      <FullLoading show={loading || loadingPublicar} />
      <Table>
        <tbody>
          <tr>
            <td>Acto administrativo</td>
            <td>{nroResolucionBora}</td>
          </tr>
          <tr>
            <td>Fecha Bora</td>
            <td>
              <SpacedSpan>{fresolucionBora}</SpacedSpan>
              <Button
                variant="primary"
                onClick={() => {
                  if (!finalLink) {
                    alert('No se cargó el link');
                  } else {
                    setVisible((e) => !e);
                  }
                }}>
                Link BORA
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
      {finalLink && (
        <Collapse in={visible}>
          <iframe src={finalLink} title="BORA" width="100%" height="600px" />
        </Collapse>
      )}
      <Accordion>
        <AccordionItem title="Denominaciones cargadas">
          <PuestosTable idLlamadoConcurso={idLlamadoConcurso} />
        </AccordionItem>
      </Accordion>
      {esCoordinadorConcursal && (
        <Button
          className="mt-5"
          variant="primary"
          onClick={() => dispatch(postPublicar({ idLlamadoConcurso }))}>
          Publicar
        </Button>
      )}

      <AlertDialog
        show={!!success || !!error}
        title={success || error}
        icon={success ? 'success' : error ? 'error' : undefined}
        btns={['accept', 'close']}
        onClose={() => {
          dispatch(cleanMsg());
          if (success) {
            dispatch(finEtapa());
            history.replace('/concursos');
          }
        }}
      />
    </Container>
  );
};

export default Publicar;
